import { render, staticRenderFns } from "./PatrolsHorizontal.vue?vue&type=template&id=d5368048&scoped=true"
import script from "./PatrolsHorizontal.vue?vue&type=script&lang=js"
export * from "./PatrolsHorizontal.vue?vue&type=script&lang=js"
import style0 from "./PatrolsHorizontal.vue?vue&type=style&index=0&id=d5368048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5368048",
  null
  
)

export default component.exports